export default __webpack_public_path__ + "static/media/tmp_logo_movilidad.29f2b316.png";